<template>
  <div class="balance-skeleton">
    <div class="balance-skeleton__section balance-skeleton__section--account">
      <div class="skeleton-line skeleton-line--label"></div>
      <div class="skeleton-line skeleton-line--number"></div>
    </div>

    <div class="balance-skeleton__section balance-skeleton__section--summary">
      <div class="skeleton-line skeleton-line--caption"></div>
      <div class="skeleton-line skeleton-line--amount"></div>
      <div class="skeleton-block skeleton-block--button"></div>
    </div>

    <div class="balance-skeleton__section balance-skeleton__section--meta">
      <div class="balance-skeleton__meta-item" v-for="n in 2" :key="`meta-${n}`">
        <div class="skeleton-line skeleton-line--meta-label"></div>
        <div class="skeleton-line skeleton-line--meta-value"></div>
      </div>
    </div>

    <div class="balance-skeleton__section balance-skeleton__section--actions">
      <div class="balance-skeleton__action" v-for="n in 2" :key="`action-${n}`">
        <div class="skeleton-circle skeleton-circle--action"></div>
        <div class="skeleton-line skeleton-line--action-title"></div>
        <div class="skeleton-line skeleton-line--action-subtitle"></div>
      </div>
    </div>

    <div class="balance-skeleton__section balance-skeleton__section--links">
      <div class="skeleton-line skeleton-line--link" v-for="n in 2" :key="`link-${n}`"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'widget-balance-skeleton'
}
</script>

<style scoped>
.balance-skeleton {
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #ffffff;
  border-radius: 24px;
  padding: 24px;
  border: 1px solid #e9f1f9;
  box-shadow: 0 12px 32px rgba(43, 89, 120, 0.12);
}

.balance-skeleton__section {
  display: flex;
  flex-direction: column;
}

.balance-skeleton__section--account {
  gap: 6px;
  align-items: flex-start;
}

.balance-skeleton__section--summary {
  gap: 16px;
  align-items: center;
  text-align: center;
}

.balance-skeleton__section--meta {
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
}

.balance-skeleton__section--actions {
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
}

.balance-skeleton__section--links {
  gap: 8px;
  align-items: center;
}

.balance-skeleton__meta-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
}

.balance-skeleton__action {
  flex: 1 1 180px;
  min-width: 160px;
  max-width: 220px;
  border-radius: 18px;
  padding: 16px 12px;
  background: #f7fafb;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  position: relative;
  overflow: hidden;
}

.balance-skeleton__action::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.45) 50%, rgba(255,255,255,0) 100%);
  animation: shimmer 1.6s infinite;
}

.balance-skeleton__action > * {
  position: relative;
  z-index: 1;
}

.skeleton-line,
.skeleton-block,
.skeleton-circle {
  position: relative;
  overflow: hidden;
  background: #eef3f7;
  border-radius: 12px;
}

.skeleton-circle {
  border-radius: 50%;
}

.skeleton-line::after,
.skeleton-block::after,
.skeleton-circle::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.55) 50%, rgba(255,255,255,0) 100%);
  animation: shimmer 1.6s infinite;
}

.skeleton-line--label {
  width: 148px;
  height: 12px;
}

.skeleton-line--number {
  width: 220px;
  height: 18px;
  border-radius: 10px;
}

.skeleton-line--caption {
  width: 180px;
  height: 14px;
}

.skeleton-line--amount {
  width: 240px;
  height: 42px;
  border-radius: 14px;
}

.skeleton-block--button {
  width: 100%;
  height: 52px;
  border-radius: 16px;
}

.skeleton-line--meta-label {
  width: 160px;
  height: 12px;
}

.skeleton-line--meta-value {
  width: 120px;
  height: 14px;
}

.skeleton-circle--action {
  width: 36px;
  height: 36px;
  border-radius: 12px;
}

.skeleton-line--action-title {
  width: 110px;
  height: 12px;
}

.skeleton-line--action-subtitle {
  width: 140px;
  height: 10px;
}

.skeleton-line--link {
  width: 220px;
  height: 12px;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
</style>
